import { Carousel } from 'ui/components/Carousel';
import { FileChip } from 'ui/components/FileChip';
import styles from './CbFileDisplay.module.css';
interface NewsfeedFile {
  id: number;
  name: string;
  url: string;
  type: string;
}
export const CbFileDisplay = ({
  files
}: {
  files: NewsfeedFile[];
}) => {
  const imageFiles = files.filter(file => file.type.includes('image'));
  const otherFiles = files.filter(file => !file.type.includes('image'));
  return <div data-sentry-component="CbFileDisplay" data-sentry-source-file="CbFileDisplay.tsx">
      {imageFiles.length > 0 && <Carousel images={imageFiles.map(file => file.url)} />}
      {otherFiles.length > 0 && <div className={styles.otherFiles}>
          {otherFiles.map(file => <FileChip file={file} />)}
        </div>}
    </div>;
};